import { Alert, Box, Button, Container, Typography } from '@mui/material';
import {
  createBrowserRouter,
  isRouteErrorResponse,
  Navigate,
  useRouteError,
} from 'react-router-dom';

import { App } from './App';
import { AcceptInvitationPage } from './AcceptInvitationPage';
import { LoginPage } from './LoginPage';
import { PasswordResetPage } from './PasswordResetPage';

function RouteError() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  return (
    <Container component="main" maxWidth="sm" sx={{ py: 10 }}>
      <Box sx={{ display: 'grid', gap: 3 }}>
        <Typography component="h1" variant="h3">
          Pagina non disponibile
        </Typography>
        <Alert severity="warning">La sezione richiesta non è disponibile ({status}).</Alert>
        <Button href="/" sx={{ justifySelf: 'start' }} variant="contained">
          Torna alla piattaforma
        </Button>
      </Box>
    </Container>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: <RouteError /> },
  {
    path: '/forgot-password',
    element: <PasswordResetPage requestOnly />,
    errorElement: <RouteError />,
  },
  { path: '/reset-password', element: <PasswordResetPage />, errorElement: <RouteError /> },
  {
    path: '/accept-invitation',
    element: <AcceptInvitationPage />,
    errorElement: <RouteError />,
  },
  {
    path: '/crm',
    element: <App />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Navigate replace to="dashboard" /> },
      {
        path: 'dashboard',
        lazy: async () => ({ Component: (await import('./DashboardPage')).DashboardPage }),
      },
      {
        path: 'companies',
        lazy: async () => ({ Component: (await import('./CompaniesPage')).CompaniesPage }),
      },
      {
        path: 'companies/:companyId',
        lazy: async () => ({ Component: (await import('./CompanyDetailPage')).CompanyDetailPage }),
      },
      {
        path: 'pipeline',
        lazy: async () => ({ Component: (await import('./PipelinePage')).PipelinePage }),
      },
      {
        path: 'projects',
        lazy: async () => ({ Component: (await import('./ProjectsPage')).ProjectsPage }),
      },
      {
        path: 'projects/:projectId',
        lazy: async () => ({ Component: (await import('./ProjectDetailPage')).ProjectDetailPage }),
      },
      {
        path: 'calendar',
        lazy: async () => ({ Component: (await import('./CalendarPage')).CalendarPage }),
      },
      {
        path: 'admin',
        lazy: async () => ({ Component: (await import('./AdminPage')).AdminPage }),
      },
    ],
  },
  {
    path: '/portal',
    element: <App />,
    errorElement: <RouteError />,
    children: [
      {
        index: true,
        lazy: async () => ({ Component: (await import('./ClientPortalPage')).ClientPortalPage }),
      },
      {
        path: 'projects/:projectId',
        lazy: async () => ({
          Component: (await import('./ClientPortalProjectPage')).ClientPortalProjectPage,
        }),
      },
    ],
  },
  { path: '/', element: <Navigate replace to="/crm" /> },
  { path: '*', element: <RouteError /> },
]);
